import * as z from 'zod'
const stringRequired = (message: string) => z.string({ required_error: message }).min(1, message)
const numberRequired = (message: string) => z.number({ required_error: message }).min(1, message)
const rollSchema = z.object({
  rollNo: z.number().nullable().optional(),
  supplierRollNo: z.number().nullable().optional(),
  lengthValue: z.number().nullable().optional(),
  lengthUnit: z.number().optional().nullable(),
  weight: z.number().min(0, 'Roll weight cannot be less than zero').nullable().optional(),
  mergeNumber: z.string().nullable().optional(),
  isActive: z.boolean().default(true),
  id: z.string().optional().nullable()
})

export const batchSchema = z.object({
  batchNo: stringRequired('Batch number is required'),
  knittingQuality: z.object({
    id: stringRequired('Please select a quality'),
    unfinishedReference: stringRequired('Quality is required')
  }),
  selectedMerges: z
    .array(z.string().min(1, 'Merge cannot be empty'))
    .nonempty('Please select at least one merge'),
  mergeUsage: z.array(
    z.object({
      mergeId: z.string().nullable().optional(),
      mergeNumber: z.string().nullable().optional(),
      kiloUsed: z
        .number()
        .min(0, 'Kilo of yarn used cannot be less than zero')
        .nullable()
        .optional(),
      kiloWasted: z
        .number()
        .min(0, 'Kilo of yarn wasted cannot be less than zero')
        .nullable()
        .optional()
    })
  ),

  rolls: z.object({
    numRolls: z.number().optional(),
    rolls: z.array(rollSchema)
  }),
  dateKnitted: z.date({
    required_error: 'Please select a date knitted'
  }),
  knittingSupplier: z.object({
    id: z.string()
  }),
  weight: z.number().optional(),
  machineNumber: stringRequired('Machine number is required'),
  bay: z.string().optional().nullable(),
  purchaseOrderReference: z.string().nullable().optional(),
  costPerKgAmount: z.number().optional().nullable(),
  costPerKgCurrency: z.number().optional().nullable(),
  costPerMetreAmount: z.number().nullable().optional(),
  costPerMetreCurrency: z.number().nullable().optional(),
  notes: z.string().optional().nullable(),
  kiloOfYarnUsed: z.number().min(0, 'Kilo of yarn used cannot be less than zero').optional(),
  kiloOfYarnWasted: z.number().min(0, 'Kilo of yarn wasted cannot be less than zero').optional()
})

export const sendToSupplierSchema = z.object({
  batchId: z.string().optional().nullable(),
  supplierId: z.string().optional().nullable(),
  supplierName: z.string().optional().nullable(),
  supplierAddressId: z.string().optional().nullable(),
  purchaseOrderNumber: z.string().optional().nullable(),
  rollStatus: z.number().optional().nullable(),
  packingListReference: z.string().optional().nullable(),
  qualityId: z.string(),
  rolls: z
    .object({
      rollId: z.string()
    })
    .array()
    .optional()
    .nullable(),
  notes: z.string().optional().nullable()
})

export const sendRollsToSupplierSchema = z.object({
  batchNumber: z.string().optional().nullable(),
  finishingSupplierId: z.string().optional().nullable(),
  finishingSupplierName: z.string().optional().nullable(),
  finishingSupplierAddressId: z.string().optional().nullable(),
  purchaseOrderNumber: z.string().optional().nullable(),
  knittingQualityId: z.string().optional().nullable(),
  finishingQualityId: z.string().optional().nullable(),
  notes: z.string().optional().nullable(),
  bay: z.string().optional().nullable(),
  rolls: z
    .array(
      z.object({
        rollId: z.string()
      })
    )
    .optional()
    .nullable()
})

export const generaPackingListSchema = z.object({
  packingListDate: z.union([z.string(), z.date()]).optional().nullable(),
  batchId: z.string().optional().nullable(),
  finishingSupplierId: z.string().optional().nullable(),
  notes: z.string()
})
